module.exports = __webpack_public_path__ + "img/wibo_bed_1.d2f54d8c.png";